import { Switch } from '@/components/ui/catalyst/switch';
import { Input } from '@/components/ui/input';

interface DateOfLossConfigProps {
  maxDays: number | null;
  onChange: (maxDays: number | null) => void;
  disabled?: boolean;
}

export const DateOfLossConfig = ({
  maxDays,
  onChange,
  disabled,
}: DateOfLossConfigProps) => {
  const enabled = maxDays !== null;

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium">Date of Loss Limit</span>
        <Switch
          checked={enabled}
          onChange={(checked) => onChange(checked ? 180 : null)}
          disabled={disabled}
          color="indigo-steel"
        />
      </div>

      {enabled && (
        <div className="flex items-center gap-2">
          <span className="text-xs text-muted-foreground">Within</span>
          <Input
            type="number"
            value={maxDays}
            onChange={(e) => onChange(parseInt(e.target.value, 10) || 1)}
            min={1}
            max={9999}
            className="h-7 w-16 text-center text-sm"
            disabled={disabled}
          />
          <span className="text-xs text-muted-foreground">days</span>
        </div>
      )}

      <p className="text-xs text-muted-foreground">
        {enabled
          ? `Cases older than ${maxDays} days flagged`
          : 'No date restriction'}
      </p>
    </div>
  );
};
